import {Box, Grid} from '@material-ui/core'
import {Paper} from '@material-ui/core'
import StateCitySelect from 'app/components/form/StateCitySelect'
import PoliticianList from 'app/components/politicians/Table/index'
import {ContainerHeader} from 'app/modules/Cities/Pages/DetailCitie/styles'
import {changePage} from 'app/modules/Politicians/redux'
import * as politiciansSelectors from 'app/modules/Politicians/redux/selectors'
import {politiciansService} from 'app/services'
import getPoliticalOffices from 'app/services/politicians/getPoliticalOffices'
import getPoliticalParties from 'app/services/politicians/getPoliticalParties'
import _t, {_} from 'i18n'
import {useSnackbar} from 'notistack'
import React, {useCallback, useEffect, useState} from 'react'
import {Button, Form} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'

const ListPoliticiansPage = ({defaultFilters, defaultSort, hideSearch, isDetailPage}) => {
  const {enqueueSnackbar} = useSnackbar()
  const dispatch = useDispatch()

  const [politicians, setPoliticians] = useState([])
  const [loading, setLoading] = useState(false)
  const [total, setTotal] = useState(0)
  const [search, setSearch] = useState({})
  const [filters, setFilters] = useState(defaultFilters || {})
  const [sorts, setDefaultSorts] = useState(defaultSort || {})
  const [politicalOffices, setPoliticalOffices] = useState([])
  const [parties, setParties] = useState([])

  const currentPage = useSelector(politiciansSelectors.getCurrentPoliticiansPage)

  const limit = useSelector(politiciansSelectors.getCurrentLimit)

  const fetchPoliticians = useCallback(
    async (searches) => {
      try {
        setLoading(true)
        const {data, total} = await politiciansService.getPoliticians({
          limit: limit.current,
          page: currentPage,
          ...searches,
          ...filters,
          ...sorts,
        })

        if (!data.length) {
          enqueueSnackbar(_`Nenhum político encontrada`, {
            variant: 'warning',
          })
          setPoliticians([])
          setTotal(0)
          setLoading(false)
          return
        }

        setTotal(total)
        setPoliticians(data)
        setLoading(false)
      } catch (error) {
        setLoading(false)
        setPoliticians([])

        enqueueSnackbar(_`Ocorreu um erro ao consultar os políticos`, {
          variant: 'error',
        })
      }
    },
    [enqueueSnackbar, limit, currentPage],
  )

  useEffect(() => {
    fetchPoliticians(search)
  }, [fetchPoliticians])

  useEffect(() => {
    getPoliticalOffices({
      limit: 1000,
      page: 1,
    }).then((res) => setPoliticalOffices(res.data))

    getPoliticalParties({
      limit: 1000,
      page: 1,
    }).then((res) => setParties(res.data))
  }, [])

  return (
    <>
      {hideSearch ? null : (
        <div className="d-flex flex-column container-citymatch-table-cards">
          <Paper className="city-politicians" style={{borderRadius: 10, marginBottom: 30}}>
            <ContainerHeader>{_`Busca por gestores públicos`}</ContainerHeader>
            <Grid container alignContent="center" alignItems="center" justify="center">
              <Grid item lg={6}>
                <Box style={{marginTop: 40, marginBottom: 40}}>
                  <Box style={{marginBottom: 30}}>
                    <Form.Control
                      autoComplete="off"
                      placeholder={_`Buscar gestor público pelo nome`}
                      name="name"
                      onChange={(ev) => setSearch({...search, name: ev.target.value})}
                      value={search.name || ''}
                    />
                  </Box>

                  <Box display="flex" style={{marginBottom: 30}}>
                    <Box display="flex" flexDirection="column" marginRight="22px" width="100%">
                      <select
                        className="form-control"
                        name="political_office"
                        placeholder={_`Cargo do gestor`}
                        value={search.political_office || ''}
                        onChange={(ev) => setSearch({...search, political_office: ev.target.value})}
                        disabled={!politicalOffices.length}>
                        <option value="">{_`Cargo do gestor`}</option>

                        {politicalOffices.map((po) => (
                          <option key={po.id} value={po.id}>
                            {po.description}
                          </option>
                        ))}
                      </select>
                    </Box>
                    <Box display="flex" flexDirection="column" width="100%">
                      <select
                        className="form-control"
                        name="party"
                        placeholder={_`Partido do gestor`}
                        value={search.party || ''}
                        onChange={(ev) => setSearch({...search, party: ev.target.value})}
                        disabled={!parties.length}>
                        <option value="">{_`Partido do gestor`}</option>
                        {parties.map((pa) => (
                          <option key={pa.id} value={pa.id}>
                            {pa.abbreviation}
                          </option>
                        ))}
                      </select>
                    </Box>
                  </Box>

                  <Box style={{marginBottom: 30}}>
                    <StateCitySelect
                      width="100%"
                      placeholder={{
                        state: _`UF`,
                        city: _`Cidade`,
                      }}
                      cityProps={search.city || ''}
                      stateProps={search.state || ''}
                      changeState={(state) => setSearch({...search, state: state?.id || '', city: ''})}
                      changeCity={(city) => setSearch({...search, city: city?.id || ''})}></StateCitySelect>
                  </Box>

                  <Box display="flex" flexDirection="row" justifyContent="space-between">
                    <Button
                      variant="outline-primary"
                      disabled={!Object.values(search).some((v) => !!v)}
                      onClick={() => {
                        setSearch({
                          name: '',
                          political_office: '',
                          city: '',
                          state: '',
                          party: '',
                        })
                        dispatch(changePage(1))
                        fetchPoliticians({})
                      }}>
                      {_`LIMPAR`}
                    </Button>
                    <Button
                      onClick={() => {
                        dispatch(changePage(1))
                        fetchPoliticians(search)
                      }}
                      disabled={!Object.values(search).some((v) => !!v)}>
                      {_`INICIAR BUSCA`}
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </div>
      )}

      <div className="d-flex flex-column">
        <PoliticianList page={currentPage} politicians={politicians} total={total} loading={loading} limit={limit} />
      </div>
    </>
  )
}

export default ListPoliticiansPage
